import { setUserAgencyStripeUserIdToTrue } from "agency/tools/common"
import { IPayment } from "payment/model"
import { paymentRPO } from "payment/repository"

export const getAllPaymentForMyAgency = (): Promise<IPayment[]> => paymentRPO.getAllPaymentsForMyAgency()

export const checkStripeCustomerId = async (): Promise<void> => {
  const customerHasBeenFound = await paymentRPO.checkStripeCustomerId()
  if (customerHasBeenFound) {
    setUserAgencyStripeUserIdToTrue()
  }
}
